import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-agent-wallet',
  templateUrl: './agent-wallet.component.html',
  styleUrls: ['./agent-wallet.component.scss']
})
export class AgentWalletComponent implements OnInit {

  @Input() set playerUUID(player_uuid:any) {
    this.player_uuid = player_uuid;
    this.init(player_uuid)
  };

  @Output() closeEvent = new EventEmitter<any>()  
  @Output() saveEvent = new EventEmitter();
  public is_loading = false;
  private player_uuid:any;

  public transaction:any = {type: "withdraw-commission"}
  public data:any = {banks:[]};
  public banks:any = []
  public setting:any = {}
  public user_permission:any = {};
  constructor(public http: HttpService) { 
    this.user_permission = this.http.getSelecetdCompanyDetail();
  }

  async ngOnInit(): Promise<void> {
    await this.http.getPermission();
  }

  async init(player_uuid) {
    this.is_loading = true
    const rtn = await this.http.post("/admin/player/get/summary/all",  {player_uuid: player_uuid, status: 1});
    this.data = rtn['player']
    this.banks = rtn['bank']
    this.setting = rtn['setting'];
    this.is_loading = false;
  }

  fcRateChange() {
    if(this.transaction.finance_charge == "true") {
      this.transaction.finance_charge_rate = this.setting.finance_charge_rate;
    } else {
      delete this.transaction.finance_charge_rate
    }

  }

  async save() {
    const data = this.transaction;
    data.player_uuid = this.player_uuid
    const s = await this.http.post("/admin/agent/transaction", data);
    this.saveEvent.emit(true)
  }

  close() {
    this.closeEvent.emit(false)
  }

}
